import React, { useState, useEffect, useRef } from 'react';
import './JobsMarkieren.css';
import { host_url } from '../../App'; // Import host_url
import Stadtplan_Bild from '../../assets/Stadtplan.jpg';
import Stadtplan_Marker from '../../assets/kreis.svg';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';

function JobsMarkieren() {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [coordinates, setCoordinates] = useState({ x: null, y: null });
  const [successMsg, setSuccessMsg] = useState('');
  const stadtplanRef = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramId = params.get('jobID');
    if (paramId) {
      setSelectedJob(paramId);
    }
  }, []);

  useEffect(() => {
    fetch(`${host_url}/jobs`)
      .then(response => response.json())
      .then(data => setJobs(data));
  }, []);

  useEffect(() => {
    if (selectedJob) {
      fetch(`${host_url}/jobs?jobid=${selectedJob}`)
        .then(response => response.json())
        .then(data => setCoordinates({ x: data.X, y: data.Y }));
    }
  }, [selectedJob]);

  const handleSelectChange = (event) => {
    setSelectedJob(event.target.value);
  };

  const handleMapClick = (event) => {
    const rect = stadtplanRef.current.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 1000;
    const y = ((event.clientY - rect.top) / rect.height) * 1000;
    setCoordinates({ x, y });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    fetch(`${host_url}/saveCoordinates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        jobID: selectedJob,
        x: coordinates.x,
        y: coordinates.y,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setSuccessMsg('Koordinaten erfolgreich gespeichert!');
        } else {
          alert('Fehler beim Speichern der Koordinaten: ' + data.error);
        }
      });
  };

  const getMarkerPosition = () => {
    if (!coordinates.x || !coordinates.y || !stadtplanRef.current) return { left: '0px', top: '0px' };
    const { offsetWidth: imgWidth, offsetHeight: imgHeight } = stadtplanRef.current;
    const left = (coordinates.x / 1000) * imgWidth;
    const top = (coordinates.y / 1000) * imgHeight;
    return { left: `${left}px`, top: `${top}px` };
  };

  return (
    <KernteamLayout>
    <div className="container jobs-markieren-container">
      <BackArrow to="/arbeit" color="gelb" />
      <h1 className="section-title orange">Job auf Karte markieren</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="dropdown">Job</label>
        <div className={`dropdown-wrapper ${selectedJob ? 'filled' : ''}`}>
          <select id="dropdown" value={selectedJob || ''} onChange={handleSelectChange}>
            <option value="" disabled>Wähle einen Job</option>
            {jobs.map(job => (
              <option key={job.JobID} value={job.JobID}>{job.Name}</option>
            ))}
          </select>
          <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
        </div>
        <input type="hidden" id="textfield1" name="textfield1" value={coordinates.x || ''} />
        <input type="hidden" id="textfield2" name="textfield2" value={coordinates.y || ''} />
        <button type="submit">Ort speichern</button>
      </form>
      <div className="logo-container" onClick={handleMapClick}>
        <img ref={stadtplanRef} src={Stadtplan_Bild} alt="Stadtplan" className="stadtplan" />
        {coordinates.x !== null && coordinates.y !== null && (
          <img
            src={Stadtplan_Marker}
            className="marker"
            style={getMarkerPosition()}
            alt={selectedJob ? selectedJob.Name : 'Marker'}
          />
        )}
      </div>
    </div>
    <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
    </KernteamLayout>
  );
}

export default JobsMarkieren;
